import { API, authFetch } from "@/App";
import { htmlToText } from "./emailImages";

export const isEmailFile = (name) => /\.(eml|msg)$/i.test(name || "");

// Uploads a .eml/.msg file; returns { html, images, subject, text } where text mimics a copy/paste of the email.
// The sender line is kept: brand rules (MARQUE) detect the shop domain, e.g. commandes@storespergolas.com.
export async function parseEmailFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await authFetch(`${API}/emails/parse-file`, { method: "POST", body: formData });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Impossible de lire l'email");
  const body = data.html ? htmlToText(data.html) : (data.text || "");
  const header = [data.sender && `De : ${data.sender}`, data.subject && `Objet : ${data.subject}`].filter(Boolean).join("\n");
  const text = body.trim() && header ? `${header}\n\n${body}` : body;
  return { ...data, text };
}
